<template>
  <div>
    <event-filter
      :load-json="true"
      :model="useModel"
      :developer="false"
      :program-value="formValues.programId"
      :include-value="true"
      :startdate="formValues.startdate"
      :enddate="formValues.enddate"
      :extra-parameters="{ type: 'class' }"
      @filteredEvents="storeEventsInStore"
      @queryUpdated="queryUpdated"
    />
  </div>
</template>

<script>
import EventFilter from '../EventFilter/EventFilter.vue'

/**
   * A wrapper for eventfilters, to pass properties and to handle the changes generated by the stepper component
   * (Mainly: watching currentStep to know when the component comes in to focus?)
   */
export default {
  components: {
    EventFilter,
  },
  props: {
    formValues: {
      required: true,
      type: Object,
    },
  },

  data: function () {
    return {
      useModel: 'AAttendance\\Models\\Event\\Event',
      canContinue: false,
    }
  },

  watch: {
    currentStep: function (val) {
      // if this value changes: it means this component has come in to focus in the stepper component
      this.emitContinue()
    },
    canContinue: function () {
      this.emitContinue()
    },
  },

  created () {
    this.emitContinue()
  },
  methods: {
    emitContinue () {
      if (this.canContinue) {
        this.$emit('canFinishStep')
      } else {
        this.$emit('canNotFinishStep')
      }
    },
    storeEventsInStore (events) {
      // if the filteredEvents functions succeeds, we know the current filter is correct,
      // so we can continue

      const eventIds = events.map(event => {
        return event.id
      })

      this.$store.dispatch('store_events', eventIds)

      this.canContinue = eventIds.length !== 0
    },
    queryUpdated (filter) {
      // the filter is changed, wait until we check if the filter is correct (by applying it)
      this.canContinue = false

      // put the filter in the store
      this.$store.dispatch('store_filter', filter)
    },
  },
}
</script>
